import { render, staticRenderFns } from "./CreditosParaRefinanciarORenovar.vue?vue&type=template&id=1880cea2"
import script from "./CreditosParaRefinanciarORenovar.vue?vue&type=script&lang=js"
export * from "./CreditosParaRefinanciarORenovar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports